import { Theme } from "../core/Theme";
import { percent } from "../core/util/Percent";

/**
 * @ignore
 */
export class KlegendTheme extends Theme {
	protected setupDefaultRules() {
		super.setupDefaultRules();
        this.rule("Legend").setAll({
            x: percent(50),
            centerX: percent(50)
        });
    }
}